// /admin/leads — the sales CRM: leads, their contacts and emails, re-contact reminders, lead sources, contact templates, agents.
// (/admin/sales is the store's revenue module, components/AdminSales.)
import { lazyRoute } from "aldoo-ra/Router/lazy-route"
import { leadsRole } from "./leads-role"

export default {
  "/admin/leads*": lazyRoute(() => import("./index"), leadsRole),
}
